import { Component } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import 'rxjs/Rx';
import {generalService} from '../services/general.service';
import { DataSourceGrid, datosGrid } from '../utils/llenarGrid.component';
import { MatDialog } from '@angular/material';
import { utils } from '../utils/utils';
import { FormControl } from '@angular/forms';
import { CurrencyPipe} from '@angular/common';
import { DataService } from '../utils/data.service';
import { generarNominaComponent } from './generarNomina/generar-nomina.component';
import { modalComponent } from '../utils/modal/modal.component';
import { ExcelService } from '../services/ExcelService.component';

@Component({
  selector: 'my-nomina',
  styles: [],
  templateUrl: 'nomina.component.html',
  providers: [generalService,CurrencyPipe,ExcelService]
})

export class nominaComponent {
  public gridDatos:any;
  public datosModelos:Array<any>;
  dataSource: DataSourceGrid | null; 
  isExtendedRow = (index, item) => item.ordenar=='2' || item.NAME == 'Administrativo';
  public _utils:utils;
  //public guardarBool = false;
  public periodoInicio = null;
  public periodoFin = null;
  public periodoAntBool = true;
  public periodoSigBool = true;
  clienteCtrl: FormControl;
  clientesFiltrados: any;
  public clientes:Array<any>;
  periodoCtrl: FormControl;
  periodosFiltrados: any;
  public periodos:Array<any>;
  anioMesCtrl: FormControl;
  anioMesFiltrados: any;
  public anioMes:Array<any>;
  public clientesArray:any;
  public periodosArray:any;
  public anioMesArray:any;
  public bloqueoAsis = false;
  public nominaFechas:any;
  public nominaData:any;
  formattedAmount: string = '';
  public estatus:Array<any>;
  public cerrado = true;
  public periodo_id:number;
  public ultimaInicio:any;
  public ultimaFin:any;
  public pimeraInicio:any;
  public primeraFin:any;
  fechaPerI = null;
  fechaPerF = null;

  constructor(private _generalService: generalService, private currencyPipe:CurrencyPipe, public dialog: MatDialog, public dataService: DataService, public excel:ExcelService) {
  	this.datosModelos = new Array();
  	this._utils = new utils();
    this.clienteCtrl = new FormControl();
    this.periodoCtrl = new FormControl();
    this.anioMesCtrl = new FormControl();
    this.nominaData = new Array<any>();
  }

  ngOnInit() {
  	this.getEstatusNomina();
    this.getClientes();
    this.getPeriodos();
    this.getAnioMes();
  }

   transformAmount(element: any, valor){
        //this.formattedAmount = this.currencyPipe.transform(valor, 'USD');
        //element.target.value = this.formattedAmount;
    }
    
    deletCurrency(element: any, valor){
      element.target.value = valor;
    }

  consultarNominaDetalle(){
    let params = null;
    let administrativo = false;
    let noAsignados = false;
    if(this.clientesArray != null && this.clientesArray != undefined){
      if(this.clientesArray == -1){
        params = "[]";
        noAsignados = true;
      }
      else if(this.clientesArray == -2){
        params = "[]";
        administrativo = true;
      }
      else
        params = this.clientesArray;
    }
    else{
      administrativo = true;
      noAsignados = true;
    }

    this._generalService.metodoCall("nomina/consultarPersonalNomina/"+params+"/"+noAsignados+"/"+administrativo+"/"+this.periodo_id).subscribe(
        result => {
           	this.datosModelos = JSON.parse(result);
          	this.gridDatos = new datosGrid(this.datosModelos);
          	this.dataSource = new DataSourceGrid(this.gridDatos);
          },
        error => {
          console.log(<any>error);
        }
      );
  }

  descargarNomina(){
    if(this.datosModelos.length > 0){
      //let columnas = ['NAME', 'formaPago', 'sueldo', 'premio', 'extra', 'faltas', 'pagosAdelantados', 
      //'vales', 'anticipo', 'prestamo', 'subtotal', 'imss', 'infonavit', 'total'];
      let columnas = ['NAME', 'formaPago', 'subtotal', 'imss', 'infonavit', 'total', 'ordenar'];
      let filename = "Quincenal del " + this.nominaData.periodo + " " + new Date().getTime();
      this.excel.exportXlsTableView(this.datosModelos, columnas, filename);
    }      
  }

  descargarNominaAnticipo(){
    if(this.datosModelos.length > 0){
      //let columnas = ['NAME', 'formaPago', 'sueldo', 'premio', 'extra', 'faltas', 'pagosAdelantados', 
      //'vales', 'anticipo', 'prestamo', 'subtotal', 'imss', 'infonavit', 'total'];
      let columnas = ['NAME', 'formaPago', 'anticipo', 'subtotal', 'total', 'ordenar'];
      let filename = "Anticipo del " + this.nominaData.periodo + " " + new Date().getTime();
      this.excel.exportXlsTableView(this.datosModelos, columnas, filename);
    }      
  }

  fechaConsulta(numero){
  	let fechaC = new Date();
  	if(numero == 0){ 		
	    this.periodoInicio = null;
	    this.periodoFin = null;
  	}
  	else{
  		let fechaArray:any = this.periodoInicio.split("-");
      let fechaArrayFin:any = this.periodoFin.split("-");
      if(numero == 1){
        if(fechaArray[2] < 14)
        {
          let mes = parseInt(fechaArray[1]);
          let anio = parseInt(fechaArray[0]);
          if(mes == 0)
          {
            mes = 11;
            anio = anio - 1;
          }
          else{
            mes = mes - 1;
          }
          this.periodoInicio = anio+ "-" + mes + "-" + 16;
        }
        else{
          this.periodoInicio = fechaArray[0] + "-" + fechaArray[1] + "-" + "01";
        }

        if(fechaArrayFin[2] < 16){
          let mes = parseInt(fechaArrayFin[1]);
          let anio = parseInt(fechaArrayFin[0]);
          if(mes == 0)
          {
            mes = 11;
            anio = anio - 1;
          }
          else{
            mes = mes - 1;
          }          
          let fecha = new Date(anio, mes, 0);
          this.periodoFin = anio + "-" + mes + "-" + fecha.getDate();
        }
        else{
          this.periodoFin = fechaArrayFin[0] + "-" + fechaArrayFin[1] + "-" + 15;
        }
      }
      else{
        if(fechaArray[2] > 15)
        {
          let mes = parseInt(fechaArray[1]);
          let anio = parseInt(fechaArray[0]);
          if(mes == 11)
          {
            mes = 0;
            anio = anio + 1;
          }
          else{
            mes = mes + 1;
          }
          this.periodoInicio = anio + "-" + mes + "-" + "01";
        }
        else{
          this.periodoInicio = fechaArray[0] + "-" + parseInt(fechaArray[1]) + "-" + 16;
        }

        if(fechaArrayFin[2] < 16){
          let mes = parseInt(fechaArrayFin[1]);
          let anio = parseInt(fechaArrayFin[0]);
          let fecha = new Date(anio, mes, 0);
          this.periodoFin = anio + "-" + mes + "-" + fecha.getDate();
        }
        else{
          let mes = parseInt(fechaArrayFin[1]);
          let anio = parseInt(fechaArrayFin[0]);
          if(mes == 11)
          {
            mes = 0;
            anio = anio + 1;
          }
          else{
            mes = mes + 1;
          }
          this.periodoFin = anio + "-" + mes + "-" + 15;
        }
      }
  		
	    if(this.periodoInicio <= this.pimeraInicio && this.periodoFin <= this.primeraFin)
	  	{
	  		this.periodoAntBool = true;
	  	}
	  	else{
	  		this.periodoAntBool = false;
	  	}

      if(this.periodoInicio >= this.ultimaInicio && this.periodoFin >= this.ultimaFin)
      {
        this.periodoSigBool = true;
      }
      else{
        this.periodoSigBool = false;
      }

  	}
  	this.getNominaPeriodo();
  }

  filtro(){
    if(this.periodosArray != null && this.periodosArray != undefined)
    {
      this.periodoInicio = this.periodosArray.START_DATE;
      this.periodoFin = this.periodosArray.END_DATE;
    }

    this.getNominaPeriodo();
  }

  cambiarPeriodos(){
    if(this.anioMesArray != null && this.anioMesArray != undefined)
    {
      this.fechaPerI = this.anioMesArray.anio + "-" + this.anioMesArray.mes + "-01";
      let fecha = new Date(this.anioMesArray.anio, this.anioMesArray.mes, 0);
      this.fechaPerF = this.anioMesArray.anio + "-" + this.anioMesArray.mes + "-" + fecha.getDate(); 
      this.getPeriodos();     
    }
    else{
      this.fechaPerI = null;
      this.fechaPerF = null;
    }
  }

  getNominaPeriodo(){
      this._generalService.metodoCall("nomina/consultarNominaPeriodo/1/"+this.periodoInicio+"/"+this.periodoFin).subscribe(
        result => {
          this.nominaData = JSON.parse(result);

          if(this.nominaData.length > 0){
            if(this.periodoInicio == null)
            {
              this.ultimaInicio = this.nominaData[0].START_DATE;
              this.ultimaFin = this.nominaData[0].END_DATE;
              this.periodoSigBool = true;
              if(this.ultimaInicio <= this.pimeraInicio && this.ultimaFin <= this.primeraFin)
              {
                this.periodoAntBool = true;
              }
              else{
                this.periodoAntBool = false;
              }
            }
            this.periodoInicio = this.nominaData[0].START_DATE;
            this.periodoFin = this.nominaData[0].END_DATE;
            this.periodo_id = this.nominaData[0].PERIOD_ID;
          	for(let i = 0; i< this.estatus.length; i++)
        		{
        			if(this.estatus[i].LOOKUP_ID == this.nominaData[0].PAYSHEET_PERIOD_STATUS)
        			{
        				if(this.estatus[i].MEANING == "Cerrado")
    		          	{
    		          		this.cerrado = true;
    		          	}
    		          	else{
    		          		this.cerrado = false;
    		          	}

    		          	break;
        			}
        		}

          	this.nominaData = this.nominaData[0];
            this.consultarNominaDetalle();
            $(".ocultarNomina").show();
          }
          else{
            $(".ocultarNomina").hide();
            this.modal("alert", "Favor de generar la primer pre-nómina");
          }
                               
        },
        error => {
          var errorMsj = <any>error;
          console.log(errorMsj);
        }
      );
  }

  modal(tipo, mensaje){
    this.dataService.modal = tipo;
    this.dataService.mensaje = mensaje;
    const dialogModal = this.dialog.open(modalComponent, {disableClose: true});
    this.dataService.dialogModal = dialogModal;
  }

  getEstatusNomina(){
      this._generalService.metodoCall("misc/consultarLookup/PAYSHEET PERIOD STATUS").subscribe(
        result => {
          this.estatus = JSON.parse(result); 
          this.getPrimerNomina();                 
        },
        error => {
          var errorMsj = <any>error;
          console.log(errorMsj);
        }
      );
  }

  getClientes(){
      this._generalService.metodoCall("misc/consultarClientes/").subscribe(
        result => {
          this.clientes = JSON.parse(result);
          this.clientesFiltrados = this.clienteFilter('');                            
        },
        error => {
          var errorMsj = <any>error;
          console.log(errorMsj);
        }
      );
  }

  getAnioMes(){
      this._generalService.metodoCall("nomina/consultarNominaPeriodo/3/null/null").subscribe(
        result => {
          this.anioMes = JSON.parse(result);
          this.anioMesFiltrados = this.anioMesFilter('');                            
        },
        error => {
          var errorMsj = <any>error;
          console.log(errorMsj);
        }
      );
  }

  getPrimerNomina(){
      this._generalService.metodoCall("nomina/consultarNominaPeriodo/5/null/null").subscribe(
        result => {
          let datos = JSON.parse(result);
          if(datos.length > 0){
            this.pimeraInicio = datos[0].START_DATE;
            this.primeraFin = datos[0].END_DATE;
          }  
          this.fechaConsulta(0);                    
        },
        error => {
          var errorMsj = <any>error;
          console.log(errorMsj);
        }
      );
  }

  getPeriodos(){
      this._generalService.metodoCall("nomina/consultarNominaPeriodo/2/"+ this.fechaPerI +"/"+this.fechaPerF+"").subscribe(
        result => {
          this.periodos = JSON.parse(result);
          this.periodosFiltrados = this.periodoFilter('');                            
        },
        error => {
          var errorMsj = <any>error;
          console.log(errorMsj);
        }
      );
  }

  onKeyUpCliente(event: any): void {
    this.clientesFiltrados = this.clienteFilter(event.target.value);
  }

  clienteFilter(val: string): Observable<any> {
    let arr: any[];
    if (val) {
      arr = this.clientes.filter(s => new RegExp(`^${val}`, 'gi').test(s.CUSTOMER_NAME));
    } else {
      arr = this.clientes;
    }
    return Observable.of(arr);
  }

  onKeyUpAnioMes(event: any): void {
    this.anioMesFiltrados = this.anioMesFilter(event.target.value);
  }

  anioMesFilter(val: string): Observable<any> {
    let arr: any[];
    if (val) {
      arr = this.anioMes.filter(s => new RegExp(`^${val}`, 'gi').test(s.anioMesS));
    } else {
      arr = this.anioMes;
    }
    return Observable.of(arr);
  }

  onKeyUpPeriodo(event: any): void {
    this.periodosFiltrados = this.periodoFilter(event.target.value);
  }

  periodoFilter(val: string): Observable<any> {
    let arr: any[];
    if (val) {
      arr = this.periodos.filter(s => new RegExp(`^${val}`, 'gi').test(s.periodo));
    } else {
      arr = this.periodos;
    }
    return Observable.of(arr);
  }

  generar(){
    const dialogRef = this.dialog.open(generarNominaComponent, {disableClose: true, width:'100%', maxWidth:'50%', panelClass: 'full-width-dialog'});
    this.dataService.dialogRef = dialogRef;
    dialogRef.afterClosed().subscribe((result) => {
      if(this.dataService.guardado){
        this._generalService.toastCall("El registro se agregó exitosamente!");
        this.periodoInicio = null;
        this.periodoFin = null;
        this.getClientes();
        this.getPeriodos();
        this.getAnioMes();
        this.getPrimerNomina(); 
      } 
    });
  }

  recalcular(){
    let dataNomina:any;
    dataNomina = this.nominaData;
    let metodo = "nomina/recalcularNomina/"+dataNomina.PERIOD_ID+"/"+sessionStorage.getItem("acslo");
      
    this._generalService.metodoCall(metodo).subscribe(
        result => {
            this.getNominaPeriodo();
            this._generalService.toastCall("Información guardada exitosamente");
        },
        error => {
          var errorMsj = <any>error;
          console.log(errorMsj);
        }
    );
  }

  actualizarNomina(){
  	let tipo = "editar";
    let dataNomina:any;
    dataNomina = this.nominaData;

    for(let i = 0; i< this.estatus.length; i++)
	{
		if(this.estatus[i].LOOKUP_ID == dataNomina.PAYSHEET_PERIOD_STATUS)
		{
			if(this.estatus[i].MEANING == "Cerrado")
          	{
          		dataNomina.cerrar = true;
          	}
          	else{
          		dataNomina.cerrar = false;
          	}
          	break;
		}
	}

    dataNomina.loacs = sessionStorage.getItem("acslo");
    let metodo = "nomina/actualizarNomina/"+dataNomina.PERIOD_ID;
      
	  this._generalService.metodoCallParamsPutPost(tipo, dataNomina, metodo).subscribe(
	      result => {
	      		this.getNominaPeriodo();
	        	this._generalService.toastCall("Información guardada exitosamente");
	      },
	      error => {
	        var errorMsj = <any>error;
	        console.log(errorMsj);
	      }
	  );
	}

	actualizarNominaDetalle(valor, PERSON_ID, LOOKUP_CODE){
	  	let tipo = "editar";
	    let dataNomina:any;
	    dataNomina = this.nominaData;
	    dataNomina.AMOUNT = valor;
	    dataNomina.PERSON_ID = PERSON_ID;
	    dataNomina.LOOKUP_CODE = LOOKUP_CODE;
      dataNomina.loacs = sessionStorage.getItem("acslo");
      
	    let metodo = "nomina/actualizarNominaDetalle/"+dataNomina.PERIOD_ID;
	      
		this._generalService.metodoCallParamsPutPost(tipo, dataNomina, metodo).subscribe(
		    result => {
		    	this.fechaConsulta(0); 
		      	this._generalService.toastCall("El registro se modificó exitosamente");
		    },
		    error => {
		      var errorMsj = <any>error;
		      console.log(errorMsj);
		    }
		);
	}


}



// WEBPACK FOOTER //
// ./src/app/nomina/nomina.component.ts